import { t } from 'ttag'
import styled from 'styled-components'

import { PB97T, BLACK } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Link } from '@h2/common/components/link'
import { Text } from '@h2/components/typography/text'
import { formatCurrency } from '@h2/../main/js/actions/assessments/budget'

const CenterCol = styled.div`
  width: 90%;
`
const IconCol = styled.div`
  margin: 0;
  height: 34px;
  width: 42px;
  background-image: url('/images/common/iconset.png');

  &.earningsicon {
    background-position: -5px -585px;
  }

  &.taxesicon {
    background-position: -367px -585px;
  }

  &.savingsicon {
    background-position: -330px -585px;
  }

  &.educationicon {
    background-position: -294px -585px;
  }

  &.transportationicon {
    background-position: -258px -585px;
  }

  &.clothesicon {
    background-position: -222px -585px;
  }

  &.entertainmenticon {
    background-position: -185px -585px;
  }

  &.foodicon {
    background-position: -149px -585px;
  }

  &.utilityicon {
    background-position: -113px -585px;
  }

  &.housingicon {
    background-position: -77px -585px;
  }

  &.healthinsuranceicon {
    background-position: -514px -585px;
  }

  &.othericon {
    background-position: -5px -585px;
  }
`
const CostCol = styled.div`
  width: 75px;
  float: right;
  font-size: 1.2em;
  height: 20px;
  color: ${({ overspent }) => (overspent ? 'red' : '#059345')};
  font-weight: bold;
`
const SectionLink = styled(Link)`
  clear: both;
  min-height: 30px;
  display: block;
  padding: 12px 7px;
  color: #000;
  &:nth-child(odd) {
    background-color: ${PB97T};
  }
`
const SummaryText = styled(Text)`
  margin: 0;
`
const VerticalSummary = ({
  budgetId,
  reverse = false,
  rounds,
  responses,
  taxes,
  fmtCurrency,
  monthlyTotal,
  options
}) => {
  const fedTaxStr = fmtCurrency(taxes.federal / 12)
  const stateTaxStr = fmtCurrency(taxes.state / 12)
  const findBudgetChoicesInRound = roundId => {
    const bAmt = responses.find(round => round.round === roundId)

    return bAmt ? bAmt.choices : []
  }
  const findBudgetAmountInRound = roundId => {
    const bAmt = responses.find(round => round.round === roundId)

    return formatCurrency((bAmt && bAmt.total) || 0)
  }
  const gapSize = '10px'

  return (
    <div>
      {rounds
        .filter(rnd => !rnd.hideFromStepper)
        .map(round => (
          <SectionLink
            href={`/budget/${budgetId}/question/${round.roundId}`}
            key={round.id}
            id={round.id}>
            <Flex alignItems="center" gap={gapSize}>
              <IconCol className={`${round.id}icon`}></IconCol>
              <CenterCol>
                <SummaryText color={BLACK} weight="bold" size="large">
                  <span>{round.name()}</span>
                </SummaryText>
                <SummaryText>
                  {findBudgetChoicesInRound(round.roundId)
                    .map(rnd => options[rnd])
                    .join(', ')}
                </SummaryText>
              </CenterCol>
              <CostCol>{findBudgetAmountInRound(round.roundId)}</CostCol>
            </Flex>
          </SectionLink>
        ))}
      <SectionLink>
        <Flex alignItems="center" gap={gapSize}>
          <IconCol className={`taxesicon`} />
          <CenterCol>
            <SummaryText color={BLACK} weight="bold" size="large">
              {t`Taxes`}
            </SummaryText>
            <SummaryText>
              {t`Though only a rough estimate, without any deductions you will likely pay around ${fedTaxStr} in Federal Taxes and ${stateTaxStr} in State Taxes.`}
            </SummaryText>
          </CenterCol>
          <CostCol>{fmtCurrency(taxes.total / 12)}</CostCol>
        </Flex>
      </SectionLink>

      {reverse && (
        <SectionLink>
          <Flex alignItems="center" gap={gapSize}>
            <IconCol className={`earningsicon`} />
            <CenterCol>
              <SummaryText color={BLACK} weight="bold" size="large">
                {t`Unspent`}
              </SummaryText>
              <SummaryText></SummaryText>
            </CenterCol>
            <CostCol overspent={monthlyTotal < 0} className={`selectedcost`}>
              {fmtCurrency(monthlyTotal)}
            </CostCol>
          </Flex>
        </SectionLink>
      )}
    </div>
  )
}

export { VerticalSummary }
